/**
 * Tiny deterministic 32-bit PRNG (Mulberry32). Used for procedural skins so
 * each snake gets a stable look across frames without storing skin state.
 *
 * Not cryptographic. Period ~ 2^32 — fine for visual variation.
 */
export const mulberry32 = (seed: number): (() => number) => {
  let t = seed >>> 0;
  return () => {
    t = (t + 0x6d2b79f5) >>> 0;
    let r = Math.imul(t ^ (t >>> 15), 1 | t);
    r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
  };
};

/** Strong-ish hash for converting names/ids → 32-bit seeds. */
export const hashStringToSeed = (s: string): number => {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
};

export const randRange = (rng: () => number, lo: number, hi: number): number =>
  lo + (hi - lo) * rng();
